import { LogisticsTicket } from "types/logisticsTicket";

export type ActionFilter = "all" | "needs_action";

export function matchesNeedsActionFilter(ticket: LogisticsTicket, actionFilter: ActionFilter) {
  if (actionFilter !== "needs_action") return true;

  return ticket.needsAction === true;
}

export function matchesCoordinatorFilter(ticket: LogisticsTicket, coordinatorFilter: string) {
  if (!coordinatorFilter || coordinatorFilter === "all") return true;

  const coordinatorId = ticket.pickup.revivnCoordinator?.id?.toString();
  if (coordinatorFilter === "unassigned") return !coordinatorId;

  return coordinatorId === coordinatorFilter;
}

export function matchesVendorFilter(ticket: LogisticsTicket, vendorFilter: string) {
  if (!vendorFilter || vendorFilter === "all") return true;

  const vendorId = ticket.winningQuote?.vendor?.id?.toString();
  if (vendorFilter === "unassigned") return !vendorId;

  return vendorId === vendorFilter;
}
